<template>
  <div class="content">

    <s-location sample title="개발 메모"/>
       <table class="tbl01">
        <colgroup>
          <col width="150px"/><col/>
          <col width="150px"/><col/>
          <col/>
        </colgroup>
         <tr>
           <td>분류</td>
           <td>메뉴 명</td>
           <td>진행상황</td>
           <td>경로</td>
         </tr>
         <template v-for="(item,idx) in list" >
           <tr :key="'tr1_'+idx" @click="item.show = !item.show" v-cursor class="faq_q">
             <td class="al_l" >{{item.DEPTH1}}</td>
             <td class="al_l" >{{item.NAME}}</td>
             <td class="al_l" >{{item.STATUS}}</td>
             <td class="al_l" >{{item.PATH}}</td>
           </tr>
           <tr :key="'tr3_'+idx" class=" faq_a" v-if="item.show">
             <td class="al_l" colspan="4">
               <span v-html="item.CTX" />
             </td>
           </tr>
         </template>
       </table>
	  </div>

</template>


<script>
let ui
export default {
  data() {
    return {
      list: {}
    }
  },
  created() {
    ui = this.$ui
    this.getData()
  },
  methods: {
    getData() {
      ui.httpGet(
        "/sample/dev_list",
        T.copyWithout(this.list, 'list'),
        ret =>
        this.list = _.get(ret, "data.list", []).map(v=>{v.show=false; return v})
      )
    },
  },
}
</script>
<style scoped>
  .tbl01 tr.faq_a td { background-color: #f5f5f5;vertical-align: top; padding:20px auto;}
</style>